import "core-js";
import * as serviceWorker from "./serviceWorker";
import "src/assets/styles/index.scss";
import "./styles.scss";
import "./assets/styles/index.scss";
import React from "react";
import ReactDOM from "react-dom";
import { Logger } from "src/helpers/logger";
import { PassportApp } from "./App";

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// In case chunk hash has changed since last deploy
window.onerror = (err) => {
  typeof err === "string" &&
    err.match(/ChunkLoadError/i) &&
    window.location.reload();
};

Logger.info("Loaded ENV", process.env);

ReactDOM.render(<PassportApp />, document.getElementById("root"));
